import axios from 'axios';
import type { InternalAxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';
import { getAuthToken } from './api';

const ANALYTICS_API_BASE_URL = (
  import.meta.env.VITE_ANALYTICS_API_URL ||
  (import.meta.env.VITE_API_BASE_URL || '').replace('/core/api/v1', '/api/analytics')
).replace(/\/+$/, '');

console.log('Analytics API Base URL:', ANALYTICS_API_BASE_URL);

const analyticsApiClient = axios.create({
  baseURL: ANALYTICS_API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

analyticsApiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    let token = getAuthToken();

    if (!token) {
      token = localStorage.getItem('access_token') ||
        localStorage.getItem('authToken') ||
        localStorage.getItem('token');
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add impersonation token if active
    const impersonationDataStr = localStorage.getItem('impersonation_data');
    if (impersonationDataStr) {
      try {
        const impersonationData = JSON.parse(impersonationDataStr);
        if (impersonationData.sessionToken) {
          config.headers['X-Impersonation-Token'] = impersonationData.sessionToken;
        }
      } catch {
        // Ignore
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

analyticsApiClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response) {
      console.error(`Analytics API Error: ${error.response.status} ${error.config?.method?.toUpperCase()} ${error.config?.url}`);
    }
    return Promise.reject(error);
  }
);

export { analyticsApiClient, ANALYTICS_API_BASE_URL };
